import directory from "./daf-provider-directory.json";
export const DAF_PROVIDERS = directory.map((provider) => ({
    ...provider,
    dafDirect: provider.id === "fidelity" || provider.id === "bny" || provider.id === "dafgiving360" ? provider.id : undefined,
}));
export const DEFAULT_DAF_PROVIDERS = ["fidelity", "bny", "dafgiving360"].map((id) => DAF_PROVIDERS.find((provider) => provider.id === id));
export const OTHER_DAF_PROVIDER = { id: "other", name: "Other" };
export const getDafProvider = (id) => id === OTHER_DAF_PROVIDER.id ? OTHER_DAF_PROVIDER : DAF_PROVIDERS.find((provider) => provider.id === id);
export const searchDafProviders = (search) => {
    const query = normalizeProviderName(search.trim());
    if (!query) {
        return [...DEFAULT_DAF_PROVIDERS, ...DAF_PROVIDERS.filter((provider) => !provider.dafDirect)];
    }
    return DAF_PROVIDERS.map((provider) => {
        const names = [provider.name, ...(provider.aliases ?? [])].map(normalizeProviderName);
        const score = Math.min(...names.map((name) => {
            if (name === query) {
                return 0;
            }
            if (name.startsWith(query)) {
                return 1;
            }
            if (name.split(/\s+/).some((word) => word.startsWith(query))) {
                return 2;
            }
            return name.includes(query) ? 3 : 4;
        }));
        return { provider, score };
    })
        .filter(({ provider, score }) => score < 4 || normalizeProviderName(provider.description ?? "").includes(query))
        .sort((left, right) => left.score - right.score)
        .map(({ provider }) => provider);
};
const normalizeProviderName = (name) => name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
